// extracted by mini-css-extract-plugin
export default {"filterContainer":"FilterPanel_filterContainer__N2d5z","filterHeader":"FilterPanel_filterHeader__scwYG"};